import { combineReducers } from 'redux';
// user-org
import auth from './auth/reducer';
import users from './users/reducer';

export default combineReducers({
  auth,
  users,
});
